export default __webpack_public_path__ + "static/media/LogoWhite.244cf7e5.svg";